import(/* webpackMode: "eager" */ "/var/app/staging/app/(with-metadata)/(main)/terms/page.tsx");
